//管理项目中所有ajax请求
import ajax from './ajax'
// export const saveOrder = obj => ajax.post('http://47.109.191.112:8888/cps/order/addOrder',obj); 
// export const getMerchant = obj=> ajax.post('http://47.109.191.112:8000/cps/merchant/getmerchant',obj);
// export const qureyPayResult = obj=> ajax.post('http://47.109.191.112:8000/cps/order/cpsResult',obj);
// export const querymchtName =obj=> ajax.post('http://47.109.191.112:8888/cps/order/getMerchantInfo',obj);


export const saveOrder = obj => ajax.post('https://cpsapp.iceforg.com.cn/cps/order/addOrder',obj); 
export const getMerchant = obj=> ajax.post('https://cpsapp.iceforg.com.cn/cps/merchant/getmerchant',obj);
export const qureyPayResult = obj=> ajax.post('https://cpsapp.iceforg.com.cn/cps/order/cpsResult',obj);
export const querymchtName =obj=> ajax.post('https://cpsapp.iceforg.com.cn/cps/order/getMerchantInfo',obj);
// export const saveOrder = obj => ajax.post('http://192.168.67.1:8888/cps/order/addOrder',obj); 
// export const getMerchant = obj=> ajax.post('http://192.168.67.1:8888/cps/merchant/getmerchant',obj);
// export const qureyPayResult = obj=> ajax.post('http://192.168.67.1:8888/cps/order/cpsResult',obj);
// export const querymchtName =obj=> ajax.post('http://192.168.67.1:8888/cps/merchant/getMerchantInfo',obj);
